module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("FIRST MARINER BOOKS EDITION 2005")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Copyright © 2004 by Stacey D’Erasmo"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ALL RIGHTS RESERVED")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")]), _c('br'), _vm._v("\nD’Erasmo, Stacey."), _c('br'), _vm._v("\nA seahorse year / Stacey D’Erasmo."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 0-618-43923-4"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-618-43923-2 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v("-10: 0-618-43923-4"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-618-61887-8 (pbk.) "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v("-10: 0-618-61887-2 (pbk.)"), _c('br'), _vm._v("\n1. San Francisco (Calif.)—Fiction. 2. California, Northern—Fiction. 3. Runaway teenagers—Fiction. 4. Lesbian mothers—Fiction. 5. Problem youth—Fiction. 6. Teenage boys—Fiction. 7. Gay fathers—Fiction. I. Title."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("PS")]), _vm._v("3554."), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("E")]), _vm._v("666S43 2004"), _c('br'), _vm._v("\n813'.54—dc22 2004042724")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("e"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-72583-3"), _c('br'), _vm._v("\nv2.1213")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("FOR INVALUABLE HELP IN WRITING THIS BOOK,")]), _c('br'), _vm._v("\nI would like to thank Jennifer Carlson, Michael Cunningham, Esopus, Gloria Fisk, Jayne Yaffe Kemp, Cammie McGovern, Catherine E. McKinley, Laurie Muchnick, Roy Parvin, Elaine Pfefferblit, Laura Pinsky, Dr. Michael Rendel, Peter Rock, Robyn Selman, the Ucross Foundation, Michael Warner, and Jacqueline Woodson. Thanks to Jeanne Fury for the rock education. And most of all, thanks to my dear Elizabeth.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0